// Maximum hours after check-in that a manually-set (Deployed) lunch break may
// start. Bounds the next-day rollover so a mistyped time -- 6:00 AM entered on
// a 7:00 AM day shift -- cannot resolve to a lunch window that falls outside
// the shift entirely and silently skips the one-hour deduction.
export const MAX_LUNCH_START_OFFSET_HOURS = 8;

// Resolve a picked lunch start (time of day only) against the check-in time,
// rolling to the next day when it falls at or before check-in. Mirrors the
// backend's resolution so the two agree on which day the break belongs to.
export const resolveLunchStart = (checkInTime, lunchStartDate) => {
  const resolved = new Date(checkInTime);
  resolved.setHours(
    lunchStartDate.getHours(),
    lunchStartDate.getMinutes(),
    0,
    0
  );
  if (resolved <= checkInTime) {
    resolved.setTime(resolved.getTime() + 864e5);
  }
  return resolved;
};

// Hours between check-in and the resolved lunch start.
export const lunchStartOffsetHours = (checkInTime, lunchStartDate) =>
  (resolveLunchStart(checkInTime, lunchStartDate) - checkInTime) / 3.6e6;

export const getSessionLunchWindow = (checkInTime, worksetup, lunchstart) => {
  if (worksetup === 3 && lunchstart) {
    const lunchStart = new Date(lunchstart);
    const lunchEnd = new Date(lunchStart.getTime() + 3.6e6);
    return { lunchStart, lunchEnd };
  }
  const lunchStart = new Date(new Date(checkInTime).setHours(12, 0, 0, 0));
  const lunchEnd = new Date(new Date(checkInTime).setHours(13, 0, 0, 0));
  return { lunchStart, lunchEnd };
};

export const isWithinLunch = (now, lunchStart, lunchEnd) =>
  now >= lunchStart && now <= lunchEnd;
